<template>
  <div
    v-if="visible"
    ref="container"
    class="badge-celebration"
    aria-hidden="true"
  />
</template>

<script setup>
import { defineProps, onBeforeUnmount, onMounted, ref } from "vue";
import lottie from "lottie-web";

const props = defineProps({ animationData: { type: Object, required: true } });
const container = ref(null);
const visible = ref(true);
let animation;
let timer;

onMounted(() => {
  if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
    visible.value = false;
    return;
  }
  animation = lottie.loadAnimation({
    container: container.value,
    renderer: "svg",
    loop: false,
    autoplay: false,
    animationData: props.animationData,
    rendererSettings: { progressiveLoad: true },
  });
  animation.addEventListener("DOMLoaded", () => {
    timer = window.setTimeout(() => animation?.play(), 1000);
  });
  animation.addEventListener("complete", () => {
    animation?.destroy();
    animation = null;
    visible.value = false;
  });
});

onBeforeUnmount(() => {
  window.clearTimeout(timer);
  animation?.destroy();
  animation = null;
});
</script>

<style scoped>
.badge-celebration {
  position: absolute;
  inset: 0;
  pointer-events: none;
}
</style>
